export const PrikljucekStatusEnum = {
  NEOPREDELJEN: '0',
  VKLOPLJEN: '2',
  PREKLICAN: '4',
  MIROVANJE: '60',
  ZACASEN_IZKLOP: '63',
  ZACASEN_IZKLOP_SU2: '35',
  PRIKLOP_V_TEKU: '11'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/PrikljucekStatusEnum.js